export const localStorageKey = 'ecommerce-admin-settings';
// import { actions as configActions } from './config'
//
// export const storedReducers = [
//   ['config', 'token'],
//   ['config', 'activeShop'],
//   ['config', 'activeShopId'],
//   ['scenes', 'orders', 'orders', 'pageSize'],
// ];

// export const actionsWhitelist = [
//   configActions.setToken().type,
//   configActions.clearToken().type,
//   configActions.userLogout().type,
//   configActions.setActiveShop().type,
// ];